import React from "react";
import PropTypes from "prop-types";

import { typeOfPAF } from "../../../../constants/typeOfPAF";

const PatientCategory = ({ registerPatient, selectTypeOfPatient }) => {
  const styles = {
    title: "text-lg font-semibold text-[#00567a] my-4",
    divider: "border-t border-[#768692] bg-[#768692]",
    section: "mt-8 mb-3 min-h-125",
    buttonBase: "mb-4 text-center",
  };

  const getButtonClass = (type) => {
    const isSelected = registerPatient?.type === type;

    return (
      styles.buttonBase +
      " " +
      "h-11.5 w-full rounded-full px-5 text-lg font-bold " +
      (isSelected
        ? "bg-[#00567a] text-white"
        : "border-0 bg-[rgba(0,114,206,0.25)] text-[#181c32] shadow-[0_0_10px_rgba(0,0,0,0.1)]")
    );
  };

  return (
    <React.Fragment>
      <div data-testid="patient-initiation-patient-category">
        <h1
          className={styles.title}
          data-testid="patient-initiation-category-title"
        >
          Please select the patient prescription authorisation form
        </h1>

        <hr className={styles.divider} />

        <div className={styles.section} data-testid="patient-initiation-category-options">
          <button
            className={getButtonClass(typeOfPAF.MALE)}
            onClick={() => selectTypeOfPatient(typeOfPAF.MALE)}
            data-testid="patient-initiation-category-male"
          >
            Male
          </button>
          <button
            className={getButtonClass(typeOfPAF.WOMANOFCP)}
            onClick={() => selectTypeOfPatient(typeOfPAF.WOMANOFCP)}
            data-testid="patient-initiation-category-woman-of-cp"
          >
            Woman of Childbearing Potential
          </button>
          <button
            className={getButtonClass(typeOfPAF.WOMANOFNCP)}
            onClick={() => selectTypeOfPatient(typeOfPAF.WOMANOFNCP)}
            data-testid="patient-initiation-category-woman-of-ncp"
          >
            Woman of Non-Childbearing Potential
          </button>
        </div>
      </div>
    </React.Fragment>
  );
};

PatientCategory.propTypes = {
  registerPatient: PropTypes.object,
  selectTypeOfPatient: PropTypes.func,
};

export default PatientCategory;
